var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5908 16.9993L12.9992 29.5867C12.4467 30.1378 11.5516 30.1378 10.9977 29.5867C10.4452 29.0356 10.4452 28.1404 10.9977 27.5893L22.5905 16.0007L10.9991 4.41211C10.4466 3.86099 10.4466 2.96584 10.9991 2.41333C11.5516 1.86222 12.4481 1.86222 13.0006 2.41333L25.5922 15.0006C26.1362 15.546 26.1362 16.4552 25.5908 16.9993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward_arrow.9d5108baa5c42407cbf5cb1d560a7d1f.svg";
export { ForwardRef as ReactComponent };